import * as React from 'react';
import { appModel } from '../../models/App';
import { Stand as MapStand } from '@simosol/stands-map';
import useMapStands from './useMapStands';
import ProjectStandsMap from './ProjectStandsMap';
import { Project } from '../../models/Projects';
import { Stand } from '../../models/Stands';

const StandMapBase = () => {
  const currentProject: Project | undefined = appModel.map.currentProject;
  if (!currentProject) return null;
  const currentStand: Stand | undefined = appModel.map.currentStand;
  const stands: Stand[] = currentProject?.stands;
  if (!stands) return null;
  const mapStands: MapStand[] = useMapStands(stands);

  const setSelectedStands = (stand?: MapStand) => {
    if (stand) {
      appModel.browser.page = { p: 'map', p1: currentProject.id, p2: stand.id };
    }
  };

  return (
    <ProjectStandsMap
      mapStands={mapStands}
      currentProject={currentProject}
      currentStand={currentStand}
      onChange={setSelectedStands}
    />
  );
};

export default StandMapBase;
